<template>
	<form
		class="form__login"
		@submit.prevent="login"
	>
		<div class="form__login__fields">
			<InputText
				id="txt_login"
				v-model="email"
				class="form__login__fields__item"
				:label="$t('typeEmail')"
				placeholder="E-mail"
			/>
			<InputPassword
				id="txt_senha"
				v-model="password"
				class="form__login__fields__item"
				:label="$t('password')"
			/>
			<div class="form__login__operations">
				<!-- <Checkbox
          id="check_logado"
          :label="$t('keepLogged')"
        /> -->
				<a @click="setStep('recover')">{{ $t('forgotPassword') }}</a>
			</div>
			<vue-recaptcha
				v-if="!ignoreRecaptcha"
				class="recaptcha"
				style="width: 100%"
				sitekey="6LdTFyQkAAAAABY0wbKeIvAlwRjQJX9lr3lHh6FW"
				@expired="expiredRecaptcha"
				@verify="verifyRecaptcha"
			/>
		</div>
		<Button
			semantic-class="mini"
			:label="$t('enter')"
			type="submit"
			:loading="isLoading"
			:disabled="password && email && !passRecaptcha && !ignoreRecaptcha"
		/>
		<p>
			{{ $t('dontHaveAccount') }}
			<span>{{ $t('createNow') }}</span>
		</p>
	</form>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { setAuthorizationAfterLogin } from '../../../services/clients/AxiosClients'
import { loginUser } from '../../../services/requests/AuthRequests'

import InputPassword from '../../../components/InputPassword/InputPassword'
import InputText from '../../../components/InputText/InputText'
// import Checkbox from "../../../components/Checkbox/Checkbox";
import Button from '../../../components/Button/Button'

import { mapMutations } from 'vuex'

export default {
	components: {
		Button,
		VueRecaptcha,
		// Checkbox,
		InputText,
		InputPassword,
	},
	props: {
		setStep: Function,
	},
	data: () => {
		const noNeedRecaptcha =
			window.location.hostname.includes('testing') ||
			window.location.hostname.includes('homologacao')
		return {
			email: '',
			password: '',
			isLoading: false,
			disabledLoginButton: false,
			passRecaptcha: false,
			ignoreRecaptcha: noNeedRecaptcha,
		}
	},
	methods: {
		...mapMutations('moduleMessages', ['mutationShowMessage']),
		expiredRecaptcha() {
			localStorage.removeItem('recaptchaToken')
			this.passRecaptcha = false
		},
		verifyRecaptcha(e) {
			localStorage.setItem('recaptchaToken', e)
			this.passRecaptcha = true
		},
		login() {
			this.disabledLoginButton = true
			this.isLoading = true

			loginUser({
				email: this.email,
				password: this.password,
			}).then((response) => {
				const { message, statusCode } = response.data

				if (statusCode !== 200) {
					this.disabledLoginButton = false
					this.isLoading = false

					this.mutationShowMessage({
						messageTitle: this.$t('problemaParaLogar'),
						messageIcon: 'fas fa-lock',
						messageType: 'error',
						messageText: message,
					})
				} else {
					this.isLoading = false
					localStorage.setItem('acquired-at', new Date().getTime())
					localStorage.setItem('jwt', `Bearer ${response.data.result.token}`)
					localStorage.setItem('email', this.email)
					localStorage.setItem('username', response.data.result.userName)
					localStorage.setItem('user-modules', JSON.stringify(response.data.result.modules))
					localStorage.setItem('fotoUrl', response.data.result.fotoUrl)
					localStorage.setItem('customerId', response.data.result.customerId)

					setAuthorizationAfterLogin()
					this.$router.push({ name: 'main' })
				}
			})

			// loginUserTreeviaGateway({
			//   email: this.email,
			//   senha: this.password,
			// }).then((response) => {
			//   localStorage.setItem(
			//     "jwt-gateway",
			//     `Bearer ${response.data.result.access_token}`
			//   );
			//   localStorage.setItem("email", this.email);

			//   setAuthorizationAfterLogin();
			// });
		},
	},
}
</script>

<style scoped>
.recaptcha {
	width: 100% !important;
	display: flex;
	justify-content: center;
	margin-top: 1rem;
}

.form__login {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	font-size: 0.75rem;
}

.form__login__fields {
	display: flex;
	flex-direction: column;
	padding-top: 3.21rem;
	padding-bottom: 3.75rem;
	width: 100%;
	justify-content: space-between;
}

.form__login__operations {
	display: flex;
	justify-content: space-between;
}

.form__login__operations a {
	cursor: pointer;
	color: (--color-navy-blue);
	font-size: 0.75rem;
}

p {
	margin-top: 0.62rem;
	text-align: center;
}

p span {
	font-weight: bold;
	cursor: pointer;
}
</style>
